import DarkGradientBellOutlineIcon from "@/assets/dark_gradient/bell_outline.svg?react";
import DarkGradientCrownIcon from "@/assets/dark_gradient/crown.svg?react";
import DarkGradientPresentIcon from "@/assets/dark_gradient/present.svg?react";
import type {FC, SVGProps} from "react";
import {useTranslation} from "react-i18next";

const AmbassadorBenefits: FC = () => {
  const {t} = useTranslation("referral");

  const renderBenefitCard = ({
    Icon,
    title,
    description,
  }: {
    Icon: FC<SVGProps<SVGSVGElement>>;
    title: string;
    description: string;
  }) => (
    <div className="bg-primary-powder flex flex-1 flex-col items-center gap-3 rounded-lg p-3">
      <div className="flex size-10 items-center justify-center rounded-md bg-white">
        <Icon className="size-3.5 shrink-0" />
      </div>
      <span className="bg-linear-(--primary-dark-gradient) bg-clip-text text-center text-sm font-semibold text-transparent">
        {title}
      </span>
      <span className="text-neutral-black text-center text-xs">{description}</span>
    </div>
  );

  return (
    <div className="flex flex-col gap-3">
      <span className="text-neutral-grey-dark text-2xs leading-2 font-semibold uppercase">
        {t("ambassador_benefits")}
      </span>
      <div className="flex flex-col items-stretch gap-2 sm:flex-row">
        {renderBenefitCard({
          Icon: DarkGradientPresentIcon,
          title: t("ambassador_benefit_free_campaigns"),
          description: t("ambassador_benefit_free_campaigns_description"),
        })}
        {renderBenefitCard({
          Icon: DarkGradientBellOutlineIcon,
          title: t("ambassador_benefit_priority_notifications"),
          description: t("ambassador_benefit_priority_notifications_description"),
        })}
        {renderBenefitCard({
          Icon: DarkGradientCrownIcon,
          title: t("ambassador_benefit_brand_representation"),
          description: t("ambassador_benefit_brand_representation_description"),
        })}
      </div>
    </div>
  );
};

export default AmbassadorBenefits;
